<template>
  <div>
    <b-row align="left">
      <b-col md="6" class="mt-2">
        <p class="mb-1 font-weight-bold">
          <font class="h4 text-primary">Internal User</font>
          &nbsp;&nbsp;&nbsp;
          <font class="h5 text-warning"></font>
        </p>
      </b-col>
      <b-col>
        <b-row>
          <b-col md="4"></b-col>
          <b-col>
            <b-row align="right" class="text-right">
              <b-col></b-col>
              <b-col md="6" align="right" class="text-right"></b-col>
              <b-col md="5" align="right" class="text-right"></b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <br />
    <div class="text-left">
      <b-row>
        <b-col md="4" class="my-1">
          <b-form-group class="mb-0">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Search"></b-form-input>
              <b-input-group-append>
                <b-button variant="primary" :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="2" class="my-1" align="right">
          <b-form-group label-cols-sm="6" label="Show" class="mb-0">
            <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="3" class="my-1"></b-col>
        <b-col md="3" class="my-1" align="right">
          <div :class="session.role == 'superadmin' ?'':'d-none'">
            <router-link :to="{name: 'addInternalUser'}">
              <b-button variant="primary">
                <img src="@/assets/create-new.svg" class="mr-2" alt />Create New
              </b-button>
            </router-link>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <br />
      </b-row>
      <section v-if="errored">
        <p>We're sorry, we're not able to retrieve this information at the moment, please try back later</p>
      </section>
      <!-- Main table element -->
      <b-table
        v-else
        responsive
        show-empty
        hover
        ref="internalUser"
        :items="getInfo"
        :fields="session.role == 'superadmin' ? fields:fields2"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        head-variant="light"
        class="bg-white"
      >
        <div slot="table-busy" class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <template v-slot:cell(created_at)="{ value, item }">
          <p class="mb-0">{{item.created_at_date_only}}</p>by
          <label class="font-weight-bold">{{item.created_by_username}}</label>
        </template>
        <template v-slot:cell(updated_at)="{ value, item }">
          <div v-if="item.updated_at_date_only == ''">-</div>
          <div v-else>
            <p class="mb-0">{{item.updated_at_date_only}}</p>by
            <label class="font-weight-bold">{{item.updated_by_username}}</label>
          </div>
        </template>
        <template v-slot:cell(action)="{ value, item }">
          <div v-show="session.role == 'superadmin'">
            <router-link
              :to="{name: 'editInternalUser', params: {id: item.id,redirect: 'InternalUser'}}"
              class="text-dark"
              v-b-tooltip.hover
              title="Edit"
            >
              <img src="@/assets/ic-edit.svg" class="mr-2" alt />
            </router-link>
            <router-link
              :to="{name: 'editInternalUserPassword', params: {id: item.id,redirect: 'InternalUser'}}"
              class="text-primary mr-2"
              v-b-tooltip.hover
              title="Edit Password"
            >
              <i class="fas fa-user-lock"></i>
            </router-link>
            <b-link
              :class="item.is_active == true ? 'text-success':'text-danger'"
              @click="userstatus({id:item.id,change:item.is_active == true ?'deactivate':'activate'})"
              v-b-tooltip.hover
              :title="item.is_active == true ?'Deactivate Account':'Activate Account'"
            >
              <i class="fas fa-power-off"></i>
            </b-link>
            <!-- <b-link class="text-primary" @click="del(item.id)">
            <i class="fas fa-user-lock"></i>
            </b-link>-->
          </div>
        </template>
      </b-table>

      <b-row class="mx-auto">
        <b-col md="4" class="mx-auto px-0">Total entries {{totalRows}}</b-col>
        <b-col md="4" class="mx-auto"></b-col>
        <b-col md="4" align="right" class="px-0">
          <b-pagination
            align="right"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      session: this.$session.get("jwt"),
      loading: false,
      errored: false,
      items: [],
      fields: [
        {
          key: "created_at",
          label: "Created",
          sortable: true,
          class: "text-left"
        },
        {
          key: "nim",
          label: "NIM",
          sortable: true,
          class: "text-center"
        },
        {
          key: "fullname",
          label: "Full Name",
          sortable: true,
          class: "text-center"
        },
        {
          key: "email",
          label: "Email",
          sortable: true,
          class: "text-center"
        },
        {
          key: "address",
          label: "Address",
          sortable: true,
          class: "text-center"
        },
        {
          key: "role_name",
          label: "Role",
          sortable: true,
          sortDirection: "desc",
          class: "text-center"
        },
        {
          key: "updated_at",
          label: "Updated",
          sortable: true,
          class: "text-left"
        },
        { key: "action", label: "Action", class: "text-center" }
      ],
      fields2: [
        {
          key: "created_at",
          label: "Created",
          sortable: true,
          class: "text-left"
        },
        {
          key: "nim",
          label: "NIM",
          sortable: true,
          class: "text-center"
        },
        {
          key: "fullname",
          label: "Full Name",
          sortable: true,
          class: "text-center"
        },
        {
          key: "email",
          label: "Email",
          sortable: true,
          class: "text-center"
        },
        {
          key: "address",
          label: "Address",
          sortable: true,
          class: "text-center"
        },
        {
          key: "role",
          label: "Role",
          sortable: true,
          sortDirection: "desc",
          class: "text-center"
        },
        {
          key: "updated_at",
          label: "Updated",
          sortable: true,
          class: "text-left"
        }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: null,
      sortDesc: true,
      sortDirection: "asc",
      filter: "",
      tanggal: new Date()
        .toJSON()
        .slice(0, 10)
        .replace(/-/g, "/"),
      routename: null,
      customerShow: false,
      infoModal: {
        id: "info-modal",
        title: "",
        content: ""
      }
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }));
    },
    rows() {
      return this.items.length;
    }
  },
  beforeCreate() {
    // this.$store
    //   .dispatch("internalUserModule/getInternalUsers")
    //   .then(response => {
    //     this.loading = false;
    //   })
    //   .catch(error => {
    //     this.$swal({
    //       type: "error",
    //       title: "Oops...",
    //       text: error.response.data,
    //       showConfirmButton: false,
    //       timer: 1500
    //     });
    //     this.loading = false;
    //   });
  },
  created() {
    // Set the initial number of items
    // this.totalRows = this.items.length;
    // this.$store.watch(
    //   state => state.internalUserModule.internal_user,
    //   (newValue, oldValue) => {
    //     this.items = newValue;
    //   }
    // );
  },
  methods: {
    getInfo(ctx, callback) {
      this.loading = true;
      const vm = this;
      const formData = new FormData();
      formData.append("search_param", ctx.filter);
      formData.append("limit", ctx.perPage);
      formData.append("page", ctx.currentPage);
      formData.append("sort_by", ctx.sortBy);
      formData.append("is_sort_asc", ctx.sortDesc);
      this.$store
        .dispatch("internalUserModule/getInternalUsersPaging", formData)
        .then(response => {
          // let arr = response.data.data.map(data => {
          //   let article = JSON.parse(data.results);
          //   return {
          //     content: article.content.id,
          //     title: article.title.id,
          //     category: article.category
          //   };
          // });
          // vm.items = arr;
          vm.totalRows = response.data.data.total_record;
          callback(response.data.data.results || []);
          this.loading = false;
        })
        .catch(error => {
          // Here we could override the busy state, setting isBusy to false
          // this.isBusy = false
          // Returning an empty array, allows table to correctly handle
          // internal busy state in case of error
          this.isBusy = false;
          callback([]);
        });
      return null;
    },
    userstatus(status) {
      this.loading = true;
      this.$store
        .dispatch("internalUserModule/changeStatus", status)
        .then(response => {
          this.$refs.internalUser.refresh();
          this.$swal({
            type: "success",
            title: `User have been ${status.change}`,
            showConfirmButton: false,
            timer: 1500
          });
          console.log(response);
        })
        .catch(error => {
          this.loading = false;
          this.serverError = error.response.data;
          console.log(error);
        });
    },
    date() {
      const currentDateWithFormat = "";
      this.tanggal = currentDateWithFormat;
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    del(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("internalUserModule/delInternalUser", id);
          this.$refs.internalUser.refresh();
          this.$swal("Deleted!", "Your file has been deleted.", "success");
        }
      });
    }
  }
};
</script>

<style>
</style>
